export default [
  {
    img: "img/theme/team-1.jpg",
    title: "Sumit Jaiswal",
    email: "abc@gmail.com",
    phone: "9821953245",
    status: "Admin",
    statusType: "success",
    completion: 60,
    statusaction: "Block",
    actioncolor: "danger",
    type: "Admin"
  },
  {
    img: "img/theme/team-2.jpg",
    title: "Mohnish Thandassery",
    email: "cdf@gmail.com",
    phone: "9821953545",
    status: "Reader",
    statusType: "info",
    completion: 100,
    statusaction: "Unblock",
    actioncolor: "light"
  },
  {
    img: "img/theme/team-3.jpg",
    title: "John Doe",
    email: "xyz@gmail.com",
    phone: "9821953275",
    status: "Reader",
    statusType: "info",
    completion: 72,
    statusaction: "Block",
    actioncolor: "danger"
  },
  {
    img: "img/theme/team-4.jpg",
    title: "Somesh Matkar",
    email: "efg@gmail.com",
    phone: "9821953245",

    status: "Admin",
    statusType: "success",
    completion: 90,
    statusaction: "Block",
    actioncolor: "danger"
  },
  {
    img: "img/theme/team-1.jpg",
    title: "Vishal Tandel",
    email: "abc@gmail.com",
    phone: "9821553245",

    status: "Admin",
    statusType: "success",
    completion: 100,
    statusaction: "Unblock",
    actioncolor: "light"
  },
  {
    img: "img/theme/team-2.jpg",
    title: "Michal Doe",
    phone: "9821453245",
    email: "pxy@gmail.com",

    status: "Reader",
    statusType: "info",
    completion: 60,
    statusaction: "Block",
    actioncolor: "danger"
  },
  {
    img: "img/theme/team-3.jpg",
    title: "Smith Doh",
    email: "xyz@gmail.com",
    phone: "9821953245",
    status: "Reader",
    statusType: "info",
    completion: 100,
    statusaction: "Unblock",
    actioncolor: "light"
  }
];
